<template>
<Slide :closeOnNavigation="true" width="405">
  <div class="navbar main">
  <ul id="navbar-main">
    <li><router-link :to="{ name: 'street-genre' , params: { id: '' }}">main</router-link></li>
    <li><a href="projects">projects (x)</a></li>
    <li><a href="projects">collectives (x)</a></li>
    <li><a href="projects">competitions (x)</a></li>
    <li><a href="projects">workshops (x)</a></li>
  </ul>
  </div>
  <div class="navbar mine">
  <ul id="navbar-mine"  v-show="isAuthenticated">
    <li><router-link :to="{ name: 'user-gallery', params: { id: username }}"><span>my</span> gallery</router-link></li>
    <li><router-link :to="{name: 'profile', params: { id: username }}"><span>my</span> profile</router-link></li>
    <li><router-link :to="{ name: 'upload', params: { id: username }}"><span>my</span> upload</router-link></li>
    <li><a href="projects"><span>my</span> projects (x)</a></li>
    <li><a href="projects"><span>my</span> collectives (x)</a></li>
    <li><a href="projects"><span>my</span> competitions (x)</a></li>
    <li><a href="projects"><span>my</span> workshops (x)</a></li>
  </ul>
  </div>
</Slide>
</template>

<script>
import { mapState } from 'vuex'
import { Slide } from 'vue-burger-menu'
import { userMixin} from '@/functions/mixins'

export default {
  name: 'Navbar',
  components: {
    Slide
  },
  mixins: [userMixin],
  computed: {
      ...mapState({
            username: state => state.user.identity.username
      })
  }
}
</script>

<style scoped lang="scss">
.nav {
  top: 65px;
}

.navbar {
  margin-top: 50px;
  &.mine {
    margin-left: -30px;
  }
}

ul {
  display: inline;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
}

li {
  width: 500px;
  text-align:left;
  transform: rotate(-5deg);
  -webkit-transform: rotate(-5deg);
  -moz-transform: rotate(-5deg);
  -ms-transform: rotate(-5deg);
  span {
    color: white;
  }
}

a {
  font-size: 100%;
  letter-spacing: 10px;
  
  text-align:left;
  &:link, &:visited {


  }
  padding: 6px 12px;
  text-decoration: none;

}

a:hover {
  color: white;
  text-decoration: none;
  font-weight: bold;
}

@media only screen and (max-width: 900px) {

    .carousel-view {
        display: none;
    }

    h1 {
        font-size: 150%;
    }

    .nav {
      top: 0px;
    }

}

</style>

<style>

 .bm-burger-button {
      position: fixed !important;
      left: 40px !important;
      top: 65px !important;
      z-index: 10000;
    }
    .bm-burger-bars {
      background-color: purple !important;
    }
    .line-style {
      position: absolute;
      height: 20%;
      left: 0;
      right: 0;
    }
    .cross-style {
      position: absolute;
      top: 12px;
      right: 2px;
      cursor: pointer;
    }
    .bm-cross {
      background: white;;
    }
    .bm-cross-button {
      height: 24px;
      width: 24px;
    }
    .bm-menu {
      height: 100%; /* 100% Full-height */
      width: 0; /* 0 width - change this with JavaScript */
      position: fixed; /* Stay in place */
      z-index: 1000; /* Stay on top */
      top: 0;
      left: 0;
      background-color: #272727 !important; /* Black*/
      overflow-x: hidden; /* Disable horizontal scroll */
      padding-top: 75px !important;
      transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
    }

    .bm-overlay {
      background: rgba(0, 0, 0, 0.3);
    }
    .bm-item-list {
      color: #b8b7ad;
      margin-left: 25px !important;
      margin-top: 25px !important;
      font-size: 20px;
    }
    .bm-item-list > * {
      display: flex;
      text-decoration: none;
      padding: 0.7em;
    }
    .bm-item-list > * > span {
      margin-left: 10px;
      font-weight: 700;
      color: white;
    }
</style>